<template>
  <v-container class="text-center" fill-height fluid>
    <v-card class="elevation-10">
      <v-card-title class="justify-center">{{textWelome}}</v-card-title>
      <v-card-text class="body-1">
        {{quizHeader}}
        <!-- início do carousel -->
        <v-carousel
          class="pa-0 fil"
          v-model="quiz"
          :cycle="cycle"
          hide-delimiter-background
          :show-arrows-on-hover="showcontrols"
          :show-arrows="showcontrols"
          :hide-delimiters="!showcontrols"
          :light="light"
        >
          <v-carousel-item class="fluid">
            <v-card class="elevation-0 pa-0 ma-2n">
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" sm="3" xs="3">
                    <v-card>
                      <v-img
                        height="140"
                        @click.stop="question1()"
                        class="white--text align-end"
                        @click="question1()"
                        src="@/assets/images/new-aluno.jpg"
                        gradient="to bottom, rgba(0,0,0,.4), rgba(0,0,0,.9)"
                      >
                        <v-card-title headline darken class="body-1">Sou Aluno</v-card-title>
                      </v-img>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                <v-col cols="12" sm="3" xs="3">
                    <v-card>
                      <v-img
                        height="140"
                        class="white--text align-end"
                        src="@/assets/images/coach-running.jpg"
                        gradient="to bottom, rgba(0,0,0,.4), rgba(0,0,0,.9)"
                      >
                        <v-card-title
                          headline
                          darken
                          class="body-1"
                          @click="question1()"
                        >Sou Treinador</v-card-title>
                      </v-img>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row dense>
                  <!-- <v-col cols="6" sm="3" xs="3">
                    <v-card>
                      <v-img
                        @click.stop="question1()"
                        class="white--text align-end"
                        @click="question1()"
                        src="@/assets/images/new-aluno2.jpg"
                        gradient="to bottom, rgba(0,0,0,.4), rgba(0,0,0,.9)"
                      >
                        <v-card-title headline darken class="body-1">Novo Aluno</v-card-title>
                      </v-img>
                    </v-card>
                  </v-col> -->
                  <v-col cols="12" sm="3" xs="3">
                    <v-card>
                      <v-img height="140"
                        @click.stop="question1()"
                        class="white--text align-end"
                        @click="question1()"
                        src="@/assets/images/cycling-aluno.jpg"
                        gradient="to bottom, rgba(0,0,0,.4), rgba(0,0,0,.9)"
                      >
                        <v-card-title headline darken class="body-1">Novo atleta</v-card-title>
                      </v-img>
                    </v-card>
                  </v-col>
                </v-row>
                <!-- <v-row dense>
                  <v-col cols="12" sm="6" xs="6">
                    <v-card>
                      <v-img
                        @click.stop="question1()"
                        class="white--text align-end"
                        @click="question1()"
                        src="@/assets/images/curious.jpg"
                        gradient="to bottom, rgba(0,0,0,.4), rgba(0,0,0,.9)"
                      >
                        <v-card-title headline darken class="body-1">Só curioso</v-card-title>
                      </v-img>
                    </v-card>
                  </v-col>
                </v-row> -->
              </v-card-text>
            </v-card>
          </v-carousel-item>

          <!-- etapa 1 -->
          <v-carousel-item>
            <v-card class="elevation-0 pa-0 ma-2n">
              <v-card-text class="pb-0">
                <v-row dense>
                  <v-col cols="6" sm="3" xs="3">
                    <v-card>
                      <v-img
                        class="white--text align-end" height="110px"
                        src="@/assets/images/sport-duathlon.jpg"
                        gradient="to bottom, rgba(0,0,0,.4), rgba(0,0,0,.6)"
                      >
                        <v-card-title headline darken class="body-1" @click="question2()">Duathlon</v-card-title>
                      </v-img>
                    </v-card>
                  </v-col>
                  <v-col cols="6" sm="3" xs="3">
                    <v-card>
                      <v-img
                        @click.stop="question2()"
                        class="white--text align-end" height="110px"
                        src="@/assets/images/sport-triathlon.jpg" 
                        gradient="to bottom, rgba(0,0,0,.4), rgba(0,0,0,.7)"
                      >
                        <v-card-title headline darken class="body-1">Triathlon</v-card-title>
                      </v-img>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="6" sm="3" xs="3">
                    <v-card>
                      <v-img
                        @click.stop="question2()"
                        class="white--text align-end" height="110px"
                        src="@/assets/images/tobias_run_side_low.jpg"
                        gradient="to bottom, rgba(0,0,0,.3), rgba(0,0,0,.7)"
                      >
                        <v-card-title headline darken class="body-1">Corrida</v-card-title>
                      </v-img>
                    </v-card>
                  </v-col>
                  <v-col cols="6" sm="3" xs="3">
                    <v-card>
                      <v-img
                        @click.stop="question2()"
                        class="white--text align-end" height="110px"
                        src="@/assets/images/sport-cycling.jpg"
                        gradient="to bottom, rgba(0,0,0,.3), rgba(0,0,0,.7)"
                      >
                        <v-card-title headline darken class="body-1">Ciclismo</v-card-title>
                      </v-img>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="6" sm="3" xs="3">
                    <v-card>
                      <v-img
                        class="white--text align-end" height="110px"
                        src="@/assets/images/sport-crossfit.jpg"
                        gradient="to bottom, rgba(0,0,0,.4), rgba(0,0,0,.9)"
                      >
                        <v-card-title headline darken class="body-1" @click="question2()">Funcional</v-card-title>
                      </v-img>
                    </v-card>
                  </v-col>
                  <v-col cols="6" sm="3" xs="3">
                    <v-card>
                      <v-img
                        @click.stop="question2()"
                        class="white--text align-end" height="110px"
                        src="@/assets/images/sport-swim.jpg"
                        gradient="to bottom, rgba(0,0,0,.4), rgba(0,0,0,.9)"
                      >
                        <v-card-title headline darken class="body-1">Natação</v-card-title>
                      </v-img>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row dense align="center" justify="center" class="fill-height">
                  <v-col cols="7" sm="3" xs="3">
                    <v-card class="">
                      <v-img
                        @click.stop="question2()"
                        class="white--text align-end" height="110px"
                        src="@/assets/images/sport-none.jpg"
                        gradient="to bottom, rgba(0,0,0,.4), rgba(0,0,0,.7)"
                      >
                        <v-card-title headline darken class="body-1">Não pratico</v-card-title>
                      </v-img>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-carousel-item>
          <!-- fim etapa 1 -->

          <!-- etapa 2 -->
          <v-carousel-item>
            <v-container class="text-center" fluid>
              <!-- <v-card class="elevation-10 mb-3"> -->
              <v-card-text class="pr-0 pl-0">
                <v-row dense >
                  <v-col width="100%">
                    <v-radio-group v-model="radioGender" row>
                      <v-radio value="1" label="Homem"/>
                      <v-radio value="2" label="Mulher"/>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col width="100%">
                    <v-text-field
                      class="body-2"
                      prepend-icon="mdi-weight-kilogram"
                      outlined
                      dense
                      clearable
                      suffix="Kg"
                      label="Meu peso"
                      maxlength="4"
                      type="numeric"
                      v-mask="'###,#'"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col width="100%">
                    <v-text-field
                      class="body-2"
                      prepend-icon="mdi-human-male-height"
                      outlined
                      dense
                      clearable
                      suffix="cm"
                      label="Minha altura"
                      maxlength="3"
                      type="numeric"
                      v-mask="'###'"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col width="100%">
                    <v-text-field
                      class="body-2"
                      prepend-icon="mdi-calendar-account"
                      outlined
                      dense
                      clearable
                      label="Aniversário (dd/mm/aaaa)"
                      maxlength=10
                      type="numeric"
                      v-mask="'##/##/#####'"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="mb-2" rounded dark @click="etapa3">
                  Próximo
                  <v-icon right dark>mdi-arrow-right-bold-circle-outline</v-icon>
                </v-btn>
              </v-card-actions> -->
              <!-- </v-card> -->
            </v-container>
          </v-carousel-item>
          <!-- fim etapa 2 -->

          <!-- etapa 3 -->
          <v-carousel-item>
            <v-container class="text-center" fluid>
              <v-card class="elevation-10 mb-3">
                <v-card-text dense class="pt-0 pb-0">
                  <v-btn
                    color="error"
                    class="ma-2"
                    fab
                    dark
                    small
                    @click="quantasVezesNaSemana(0)"
                  >0</v-btn>
                  <v-btn
                    color="warning"
                    class="ma-2"
                    fab
                    dark
                    small
                    @click="quantasVezesNaSemana(1)"
                  >1-2</v-btn>
                  <v-btn
                    color="blue lighten-1"
                    class="ma-2"
                    fab
                    dark
                    small
                    @click="quantasVezesNaSemana(2)"
                  >3+</v-btn>
                </v-card-text>
              </v-card>

              <!-- quanto tempo sedentario -->
              <v-card
                class="elevation-10 mb-3"
                :v-model="showTempoSedentarioPanel"
                v-show="showTempoSedentarioPanel"
              >
                <v-card-subtitle>Há quanto tempo está sedentário?</v-card-subtitle>
                <v-card-text dense class="pt-0 pb-2">
                  <v-btn
                    color="primary lighten-2"
                    class="ma-2"
                    dark
                    small
                    @click="ultimaPergunta()"
                  >menos de 1 ano</v-btn>
                  <v-btn
                    color="primary lighten-2"
                    class="ma-2"
                    dark
                    small
                    @click="ultimaPergunta()"
                  >mais de 1 ano</v-btn>
                </v-card-text>
              </v-card>

              <!-- faz mais de 50 min -->
              <v-card
                class="elevation-10 mb-3"
                :v-model="showFazMaisde50"
                v-show="showFazMaisde50"
                transition="fade-transition"
              >
                <v-card-subtitle>Algum dia faz mais de 50 min?</v-card-subtitle>
                <v-card-text dense class="pt-0 pb-2">
                  <v-btn
                    color="primary lighten-2"
                    class="ma-2"
                    dark
                    small
                    @click="ultimaPergunta()"
                  >Sim</v-btn>
                  <v-btn
                    color="primary lighten-2"
                    class="ma-2"
                    dark
                    small
                    @click="ultimaPergunta()"
                  >Não</v-btn>
                </v-card-text>
              </v-card>

              <!-- faz mais e 4 h? -->
              <v-card
                class="elevation-10 mb-3"
                :v-model="showHorasPorSemana"
                v-show="showHorasPorSemana"
              >
                <v-card-subtitle>Quantas horas treina por semana?</v-card-subtitle>
                <v-card-text dense class="pt-0 pb-2">
                  <v-btn
                    color="primary"
                    class="ma-2"
                    dark
                    small
                    @click="ultimaPergunta()"
                  >menos de 4h</v-btn>
                  <v-btn
                    color="primary"
                    class="ma-2"
                    dark
                    small
                    @click="ultimaPergunta()"
                  >mais de 4h</v-btn>
                </v-card-text>
              </v-card>
            </v-container>
          </v-carousel-item>
          <!-- fim etapa 3 -->

          <!-- ultima pergunta -->
          <v-carousel-item>
            <v-container class="text-center" fluid>
              <!-- <v-card class="elevation-10 mb-3"> -->
              <v-card-text dense class="pt-2 pb-0">
                <v-radio-group v-model="radios" dense>
                  <v-radio
                    label="Não tenho hábitos muito saudáveis mas me sinto bem assim."
                    value="1"
                  ></v-radio>
                  <v-divider class="mb-2"></v-divider>
                  <v-radio
                    label="Gostaria de ter uma rotina mais saudável mas ainda não consigo me organizar."
                    value="2"
                  ></v-radio>
                  <v-divider class="mb-2"></v-divider>
                  <v-radio
                    label="Tenho hábitos saudáveis e pretendo continuar com um rutina regrada."
                    value="3"
                  ></v-radio>
                  <v-divider class="mb-2"></v-divider>
                  <v-radio
                    label="Quero ter hábitos mais saudáveis e pretendo começar o quando antes."
                    value="4"
                  ></v-radio>
                  <v-divider class="mb-2"></v-divider>
                  <v-radio
                    label="Já tive um estilo de vida saudável mas não consegui manter por falta de tempo e motivação."
                    value="5"
                  ></v-radio>
                  <v-divider class="mb-2"></v-divider>
                  <v-radio
                    label="Estou adotando o estilo da vida mas saudável que adotei e pretendo seguir assim por mais tempo."
                    value="6"
                  ></v-radio>
                </v-radio-group>
              </v-card-text>
              <!-- </v-card> -->
            </v-container>
          </v-carousel-item>
        </v-carousel>
        <!-- fim do carousel -->
      </v-card-text>
      <v-card-actions class="text">
        <v-btn color="primary" class outlined dark @click="goBack" v-show="radios == null && this.quiz > 0">
          Voltar
          <v-icon right dark>mdi-arrow-left-bold-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" class outlined dark @click="goNext" v-show="this.quiz < 4">
          Próximo
          <v-icon right dark>mdi-arrow-right-bold-circle</v-icon>
        </v-btn>
        <v-btn color="primary" class rounded dark to="calendar" v-show="radios != null">
          Finalizar
          <v-icon right dark>mdi-account-check-outline</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: {
    source: String
  },
  data: () => ({
    
    textWelome : 'Olá Kelly Slater',

    //slider e quiz:
    quizHeader: "Antes de começar, que tal a gente se conhecer melhor? Fala pra nós, você é...",
    answer: "",
    quiz: null,
    cycle: false,
    showcontrols: false,
    light: true,

    //dados das respostas:
    atividadesPorSemana: null,
    tempoSedentario: null,
    fazMaisde50: false,
    horasPorSemana: null,
    radios: null,
    radioGender : null,

    //paineis:
    showTempoSedentarioPanel: false,
    showFazMaisde50: false,
    showHorasPorSemana: false
  }),
  methods: {
    question1() {
      this.textWelome = '';
      this.quizHeader = "Beleza. Conta pra gente se você pratica algum esporte hoje, qual é?";
      this.quiz = 1;
    },
    question2() {
      this.quizHeader = "Ok! Agora me diz alguns números...";
      this.quiz = 2;
    },
    etapa3() {
      this.quizHeader =
        "Quantas vezes por semana você propriociona felicidade para o corpo com atividade física?";
      this.quiz = 3;
    },
    ultimaPergunta() {
      this.quizHeader =
        "Quando o assunto é ter uma rotina saudável, como você diria que se sente?";
      this.quiz = 4;
    },
    quantasVezesNaSemana(val) {
      this.atividadesPorSemana = val;

      switch (this.atividadesPorSemana) {
        case 0:
          this.showTempoSedentarioPanel = true;
          this.showFazMaisde50 = false;
          this.showHorasPorSemana = false;
          break;
        case 1:
          this.showTempoSedentarioPanel = false;
          this.showFazMaisde50 = true;
          this.showHorasPorSemana = false;
          break;
        case 2:
          this.showTempoSedentarioPanel = false;
          this.showFazMaisde50 = false;
          this.showHorasPorSemana = true;
          break;
      }
    },
    restartQuiz() {
      this.quiz = 0;
      this.textWelome = 'Olá Kelly Slater';
    },
    goBack() {
      if(this.quiz > 0){
        this.quiz = this.quiz -1;
        if(this.quiz == 0){
          this.textWelome = 'Olá Kelly Slater';
        }
      }
      if(this.quiz == 3){
       this.quizHeader =
        "Quantas vezes por semana você propriociona felicidade para o corpo com atividade física?"; 
      }else if (this.quiz == 2){
        this.quizHeader = "Ok! Agora me diz alguns números...";
      }else if (this.quiz == 4){
        this.quizHeader =
        "Quando o assunto é ter uma rotina saudável, como você diria que se sente?";
      }
    },
    goNext() {
      if(this.quiz < 4){
        this.quiz = this.quiz + 1;
      }
      if(this.quiz == 3){
       this.quizHeader =
        "Quantas vezes por semana você propriociona felicidade para o corpo com atividade física?"; 
      }else if (this.quiz == 2){
        this.quizHeader = "Ok! Agora me diz alguns números...";
      }else if (this.quiz == 4){
        this.quizHeader =
        "Quando o assunto é ter uma rotina saudável, como você diria que se sente?";
      }
    }
  }
};
</script>


<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>